import { Divider, Flex, Form, Input, Typography } from "antd";
import { useEffect, useState } from "react";
import PrimaryButton from "../Forms/PrimaryButton";
import { useApiCall } from "../../services/api";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import { resendOtpMessage, timeLimitForOtp } from "../../constant";

const { Title, Paragraph } = Typography;

const OtpModal = ({
  formType = "client",
  step,
  formData,
  handleResendOtp,
  handleFinish,
  title,
  is_customer = false,
  verifyEmailOtp = true,
  verifyPhoneOtp = true,
  onPrevious,
  isOwnProfile = false,
}) => {
  const { postApi, loading } = useApiCall();
  const [emailForm] = Form.useForm();
  const [phoneForm] = Form.useForm();

  const { showPopup } = useGlobalModal();

  const [verified, setVerified] = useState({
    email: !verifyEmailOtp,
    phone: !verifyPhoneOtp,
  });

  const [loader, setLoader] = useState({ email: false, phone: false });

  useEffect(() => {
    setVerified({
      email: !verifyEmailOtp,
      phone: !verifyPhoneOtp,
    });
  }, [verifyEmailOtp, verifyPhoneOtp]);
  const [timer, setTimer] = useState(timeLimitForOtp);
  const [timer2, setTimer2] = useState(timeLimitForOtp);

  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    if (timer2 === 0) return;
    const interval = setInterval(() => {
      setTimer2((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timer2]);

  useEffect(() => {
    setTimer(timeLimitForOtp);
    setTimer2(timeLimitForOtp);
  }, [step]);

  const localHandleResendOtp = async (type = "email") => {
    const res = await handleResendOtp(type, true);

    if (res) {
      type === "phone" ? setTimer2(timeLimitForOtp) : setTimer(timeLimitForOtp);
    }
  };

  const handleVerify = async (values, type) => {
    setLoader((prev) => ({ ...prev, [type]: true }));
    const data = { [type]: formData[type], otp: values[`${type}Otp`] };

    const apiRoute =
      formType === "client"
        ? `customer/register-verify-otp-${type}`
        : `sales/employee/signup-verify-otp-${type}`;
    const res = await postApi(apiRoute, data);

    if (res?.status) {
      if (is_customer) {
        return showPopup({
          title: null,
          content: (
            <span className="custom-modal-title">
              <span className="capitalize">{type}</span> OTP verified
              successfully.
            </span>
          ),
          onOk: () => setVerified((prev) => ({ ...prev, [type]: true })),
          className: "custom-success-modal",
        });
      } else {
        setVerified((prev) => ({ ...prev, [type]: true }));
      }
    } else {
      if (type === "email") {
        emailForm.setFieldsValue({ emailOtp: "" });
      } else {
        phoneForm.setFieldsValue({ phoneOtp: "" });
      }
    }
    if (!res?.status || (!verified.email && !verified.phone)) {
      showPopup({
        title: null,
        content: <span className="custom-modal-title">{res.message}</span>,
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
    }
    setLoader((prev) => ({ ...prev, [type]: false }));
  };

  useEffect(() => {
    if (verified.email && verified.phone) {
      handleFinish();
    }
  }, [verified]);

  const handleKeyDown = (e) => {
    if (
      ["Backspace", "Tab", "Delete", "ArrowLeft", "ArrowRight"].includes(
        e.key,
      ) ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <Title className="input-css font-abhaya" level={2}>
        {title}
      </Title>
      {verifyPhoneOtp && (
        <Form
          name="trigger"
          layout="vertical"
          autoComplete="off"
          form={phoneForm}
          onFinish={(values) => handleVerify(values, "phone")}
        >
          <Title className="input-css mt-6" level={5}>
            Enter the 6-digit code sent to{" "}
            {`****${formData.phone?.slice(-4) || "****"}`}
          </Title>
          <Flex gap={20} className="otp-modal flex w-full justify-center">
            <Form.Item name="phoneOtp" className="!mb-1">
              <Input.OTP
                variant="filled"
                inputMode="numeric"
                onKeyDown={handleKeyDown}
                disabled={verified.phone || loading}
                onChange={(value) => {
                  const cleanValue = value.replace(/\D/g, "");
                  phoneForm.setFieldsValue({ phoneOtp: cleanValue });
                  if (cleanValue.length === 6) {
                    phoneForm.submit();
                  }
                }}
              />
            </Form.Item>
            <PrimaryButton
              noIcon
              text="Verify"
              type="submit"
              className="flex-1 !m-0"
              verified={verified.phone}
              disabled={
                verified.phone ||
                phoneForm.getFieldValue("phoneOtp")?.length !== 6
              }
              loading={loader.phone}
            />
          </Flex>
          {!verified.phone && (
            <p className="text-md">
              Didn't receive?{" "}
              {timer2 > 0 ? (
                <span className="text-gray-500">
                  {resendOtpMessage(timer2)}
                </span>
              ) : (
                <strong
                  className="cursor-pointer text-red-700"
                  onClick={() => localHandleResendOtp("phone")}
                >
                  Resend OTP
                </strong>
              )}
            </p>
          )}
          <Paragraph className="text-gray-700 text-sm">
            Please check{" "}
            {is_customer || isOwnProfile
              ? "your"
              : formType === "client"
                ? "client's"
                : "employee's"}{" "}
            phone.
          </Paragraph>
        </Form>
      )}

      {verifyPhoneOtp && verifyEmailOtp && (
        <Divider variant="solid" style={{ color: "#a33434" }} />
      )}
      {verifyEmailOtp && (
        <Form
          name="trigger"
          layout="vertical"
          autoComplete="off"
          form={emailForm}
          onFinish={(values) => handleVerify(values, "email")}
        >
          <Title className="input-css" level={5}>
            Enter the 6-digit code sent to {`${formData.email || ""}`}
          </Title>
          <Flex gap={20} className="otp-modal flex w-full justify-center ">
            <Form.Item name="emailOtp" className="!mb-1">
              <Input.OTP
                variant="filled"
                inputMode="numeric"
                onKeyDown={handleKeyDown}
                disabled={verified.email || loading}
                onChange={(value) => {
                  const cleanValue = value.replace(/\D/g, "");
                  emailForm.setFieldsValue({ emailOtp: cleanValue });
                  if (cleanValue.length === 6) {
                    emailForm.submit();
                  }
                }}
              />
            </Form.Item>
            <PrimaryButton
              noIcon
              text="Verify"
              type="submit"
              className="flex-1 !m-0"
              verified={verified.email}
              disabled={
                verified.email ||
                emailForm.getFieldValue("emailOtp")?.length !== 6
              }
              loading={loader.email}
            />
          </Flex>
          {!verified.email && (
            <p className="text-md">
              Didn't receive?{" "}
              {timer > 0 ? (
                <span className="text-gray-500">{resendOtpMessage(timer)}</span>
              ) : (
                <strong
                  className="cursor-pointer text-red-700"
                  onClick={() => localHandleResendOtp("email")}
                >
                  Resend OTP
                </strong>
              )}
            </p>
          )}
          <Paragraph className="text-gray-700 text-sm">
            Please check{" "}
            {is_customer || isOwnProfile
              ? "your"
              : formType === "client"
                ? "client's"
                : "employee's"}{" "}
            email.
          </Paragraph>
        </Form>
      )}

      {onPrevious && (
        <div className="w-full flex justify-center mt-4">
          <PrimaryButton
            text="Previous"
            onClick={onPrevious}
            btnType="secondary"
          />
        </div>
      )}
    </>
  );
};

export default OtpModal;
